import React from 'react';
import { SVGS } from '../../assets';
import './error-toast.scss';

interface ErrorToastProps {
  isError: boolean;
  errorMsg: string;
  onClose: () => void;
}

export const ErrorToast: React.FC<ErrorToastProps> = ({
  isError,
  errorMsg,
  onClose,
}) => {
  return (
    <div className={`error-toast ${isError ? 'error' : 'hide'}`}>
      <img src={SVGS.ErrorWhite} className="error-toast-icon" />
      <span className="error-toast-text primary-font-regular">{errorMsg}</span>
      <img
        src={SVGS.CloseWhite}
        alt=""
        className="error-toast-close"
        onClick={onClose}
      />
    </div>
  );
};
